// extracted by mini-css-extract-plugin
export default {"FakePreview":"_FakePreview--omcDA","ThumbNailPlaceholder":"_ThumbNailPlaceholder--GoFS_","PlayButton":"_PlayButton--KFRiS"};